import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';

@Component({
    selector: 'app-info-dialog',
    styleUrls: ['./info-dialog.component.scss'],
    templateUrl: './info-dialog.component.html',
    imports: [MatIconModule, MatDialogModule, MatButtonModule],
})
export class InfoDialogComponent {
    dialogRef = inject<MatDialogRef<InfoDialogComponent>>(MatDialogRef);

    public text: string;
    public title: string;
    public titleIcon: string;
    public buttonText: string;

    constructor() {
        const data = inject<{
            text?: string;
            title?: string;
            titleIcon?: string;
            buttonText?: string;
        }>(MAT_DIALOG_DATA);

        this.text = data?.text;
        this.title = data?.title;
        this.titleIcon = data?.titleIcon;
        this.buttonText = data?.buttonText;
    }
}
